export default __webpack_public_path__ + "src/image/discord_logo.png";